import ARCORequest from './ARCORequest';
import AuthorizationForProcessingPersonalDataATS from './AuthorizationForProcessingPersonalDataATS';
import CookiesPolicy from './CookiesPolicy';
import {
  MEMBERSHIP_POLICY_ROUTE_PATH,
  PAYG_POLICY_ROUTE_PATH,
  PRIVACY_ROUTE_PATH,
  TERMS_AND_CONDITIONS_ROUTE_PATH,
} from './constants';
import MembershipPolicy from './MembershipPolicy';
import PAYGPolicy from './PAYGPolicy';
import PersonalDataProtectionPolicyCrehanaATS from './PersonalDataProtectionPolicyCrehanaATS';
import PrivacyNoticeCo from './PrivacyNoticeCo';
import PrivacyNoticeMx from './PrivacyNoticeMx';
import PrivacyPolicy from './PrivacyPolicy';
import RefundPolicy from './RefundPolicy';
import SecurityPrivacyPolicy from './SecurityPrivacyPolicy';
import { SLA } from './SLA';
import TeacherAgreement from './TeacherAgreement';
import TermsAndConditions from './TermsAndConditions';
import TermsAndConditionsB2B from './TermsAndConditionsB2B';
import TermsAndConditionsENB2B from './TermsAndConditionsENB2B';

export interface Route {
  key: string;
  path: string;
  exact: boolean;
  component: any;
  updatedAt: string;
  title?: string;
  subtitle?: string;
}

export {
  BASE_URL,
  PRIVACY_CL_ROUTE,
  PRIVACY_CO_ROUTE,
  PRIVACY_MX_ROUTE,
  PRIVACY_PE_ROUTE,
  PRIVACY_ROUTES,
} from './constants';

export const TERMS_AND_CONDITIONS_ROUTE = {
  key: 'TERMS_AND_CONDITIONS',
  path: TERMS_AND_CONDITIONS_ROUTE_PATH,
  exact: true,
  component: TermsAndConditions,
  updatedAt: '16 de Junio de 2026',
};

export const TERMS_AND_CONDITIONS_B2B_ROUTE = {
  key: 'TERMS_AND_CONDITIONS_B2B',
  path: '/terminos-y-condiciones-b2b/',
  exact: true,
  component: TermsAndConditionsB2B,
  updatedAt: '16 de Junio de 2026',
};

export const TERMS_AND_CONDITIONS_B2B_EN_ROUTE = {
  key: 'TERMS_AND_CONDITIONS_B2B_EN',
  path: '/terms-and-conditions-b2b/',
  exact: true,
  component: TermsAndConditionsENB2B,
  updatedAt: '16 de Junio de 2026',
};

export const PRIVACY_ROUTE = {
  key: 'PRIVACY',
  path: PRIVACY_ROUTE_PATH,
  exact: false,
  component: PrivacyPolicy,
  updatedAt: '16 de Junio de 2026',
};

export const AUTHORIZATION_FOR_PROCESSING_PERSONAL_DATA_ATS_ROUTE = {
  key: 'AUTHORIZATION_FOR_PROCESSING_PERSONAL_DATA_ATS',
  path: '/autorizacion-tratamiento-datos-personales-ats/',
  exact: true,
  component: AuthorizationForProcessingPersonalDataATS,
  updatedAt: '16 de Junio de 2026',
};

export const PERSONAL_DATA_PROTECTION_POLICY_CREHANA_ATS_ROUTE = {
  key: 'PERSONAL_DATA_PROTECTION_POLICY_CREHANA_ATS',
  path: '/politica-proteccion-datos-personales-crehana-ats/',
  exact: true,
  component: PersonalDataProtectionPolicyCrehanaATS,
  updatedAt: '16 de Junio de 2026 - CÓDIGO: PDP-PL-01',
};

export const PRIVACY_NOTICE_MX_ROUTE = {
  key: 'PRIVACY_NOTICE_MX',
  path: '/avisos-de-privacidad/mx/',
  exact: true,
  component: PrivacyNoticeMx,
  updatedAt: '16 de Junio de 2026',
};

export const PRIVACY_NOTICE_CO_ROUTE = {
  key: 'PRIVACY_NOTICE_CO',
  path: '/avisos-de-privacidad/co/',
  exact: true,
  component: PrivacyNoticeCo,
  updatedAt: '16 de Junio de 2026',
};

export const MEMBERSHIP_POLICY_ROUTE = {
  key: 'MEMBERSHIP_POLICY',
  path: MEMBERSHIP_POLICY_ROUTE_PATH,
  exact: false,
  component: MembershipPolicy,
  updatedAt: '16 de Junio de 2026',
};

export const PAYG_POLICY_ROUTE = {
  key: 'PAYG_POLICY',
  path: PAYG_POLICY_ROUTE_PATH,
  exact: true,
  component: PAYGPolicy,
  updatedAt: '16 de Junio de 2026',
};

export const TEACHER_AGREEMENT_ROUTE = {
  key: 'TEACHER_AGREEMENT',
  path: '/acuerdo-para-profesores/',
  exact: true,
  component: TeacherAgreement,
  updatedAt: '16 de Junio de 2026',
};

export const COOKIES_POLICY_ROUTE = {
  key: 'COOKIES_POLICY',
  path: '/politica-de-cookies/',
  exact: true,
  component: CookiesPolicy,
  updatedAt: '16 de Junio de 2026',
};

export const ARCO_ROUTE = {
  key: 'ARCO_REQUEST',
  path: '/solicitud-arco/',
  exact: true,
  component: ARCORequest,
  updatedAt: '16 de Junio de 2026',
};

export const REFUND_POLICY_ROUTE = {
  key: 'REFUND_POLICY',
  path: '/politicas-de-reembolso/',
  exact: true,
  component: RefundPolicy,
  updatedAt: '16 de Junio de 2026',
};

export const SECURITY_AND_PRIVACY_POLICY_ROUTE = {
  key: 'SECURITY_AND_PRIVACY_POLICY',
  path: '/politicas-de-seguridad-y-privacidad/',
  exact: true,
  component: SecurityPrivacyPolicy,
  updatedAt: '16 de Junio de 2026',
};

export const SLA_ROUTE = {
  key: 'SLA',
  path: '/service-level-agreement',
  exact: true,
  component: SLA,
  updatedAt: '18 de Junio de 2026',
  title: 'Acuerdo Maestro de Nivel de Servicio (ANS)',
  subtitle:
    'Documento único y exclusivo de niveles de servicio · Aplicable a todos los contratos base',
};

const ROUTES: Route[] = [
  TERMS_AND_CONDITIONS_ROUTE,
  PRIVACY_ROUTE,
  PRIVACY_NOTICE_MX_ROUTE,
  PRIVACY_NOTICE_CO_ROUTE,
  // PRIVACY_NOTICE_CO_ROUTE,
  MEMBERSHIP_POLICY_ROUTE,
  PAYG_POLICY_ROUTE,
  TEACHER_AGREEMENT_ROUTE,
  COOKIES_POLICY_ROUTE,
  ARCO_ROUTE,
  REFUND_POLICY_ROUTE,
  SECURITY_AND_PRIVACY_POLICY_ROUTE,
  TERMS_AND_CONDITIONS_B2B_ROUTE,
  TERMS_AND_CONDITIONS_B2B_EN_ROUTE,
  SLA_ROUTE,
  AUTHORIZATION_FOR_PROCESSING_PERSONAL_DATA_ATS_ROUTE,
  PERSONAL_DATA_PROTECTION_POLICY_CREHANA_ATS_ROUTE,
];

export default ROUTES;
